<template>
  <div>
    <div>
      <div class="text-xs-right">
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs6>
          <v-btn @click="showAdd" outline color="primary">Add</v-btn>
          <v-dialog v-model="editrewarddialog" width="720px" persistent
            ><v-card v-if="editrewarddialog">
              <RewardEdit
                @onsave="onsave"
                :edittype="edittype"
                :editdata="editdata"
                @close="editrewarddialog = false"
              ></RewardEdit></v-card
          ></v-dialog>
        </v-flex>
        <v-flex xs6>
          <RewardCategory @change="onChangeCategory"></RewardCategory>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-right">
      <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>
    <div class="text-xs-center mt-5" v-if="loading">
      <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
    </div>
    <div v-else id="body-reward" class="mt-2">
      <div v-if="items.length">
        <div
          v-for="(item, index) in items"
          :key="`reward-card-${index}`"
          style="border: 2px solid #1548a7; border-radius: 16px; position: relative"
          class="pa-2 elevation-3 mb-3"
        >
          <v-layout row wrap class="px-4 ma-0">
            <v-flex xs3>
              <div>
                <v-img aspect-ratio="1" :src="item.image"></v-img>
              </div>
            </v-flex>
            <v-flex xs9 class="pl-4">
              <div>
                <h6 style="color: black">{{ item.name }}</h6>
                <div>
                  <span>Description : </span>
                  <span>{{ item.description }}</span>
                </div>
                <div>
                  <span>รหัสสินค้า : </span>
                  <span>{{ item.sku }}</span>
                </div>
                <div>
                  <span>Quantity : </span>
                  <span>{{ item.quantity }}</span>
                </div>
                <div>
                  <span>Start Date : </span>
                  <span>{{ item.start_time | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
                <div>
                  <span>End Date : </span>
                  <span>{{ item.end_time | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
              </div>

              <div style="color: #1548a7; float: right; font-size: 18px">
                ใช้ {{ item.points }} คะแนน
              </div>
            </v-flex>
            <div style="position: absolute; right: 5px; top: 3px">
              <v-btn @click="showEditReward(item)" icon
                ><v-icon color="#1548a7">edit</v-icon></v-btn
              >
              <v-btn @click="deleteReward(item)" icon
                ><v-icon color="#1548a7">delete</v-icon></v-btn
              >
            </div>
          </v-layout>
        </div>
      </div>
      <div v-else>
        <div class="grey--text text-xs-center mt-5" style="font-size: 22px">ไม่พบข้อมูล</div>
      </div>
    </div>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <!-- <label>{{ $t('รหัสสาขาของห้าง') }}</label> -->
                <input v-model="filter.search" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RewardCategory from './RewardCategory.vue'
import RewardEdit from './RewardEdit.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    RewardCategory,
    RewardEdit
  },
  data() {
    return {
      filter: {
        search: ''
      },

      items: [],
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      editrewarddialog: false,
      loading: false,
      edittype: '',
      editdata: '',
      selectedcategory: '',
      showCategory: false,
      cardData: []
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
  },
  methods: {
    showEditReward(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.editrewarddialog = true
    },
    onsave() {
      this.getData()
      this.editrewarddialog = false
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    deleteReward(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              id: item.id
            }
            this.loading = true
            api.deleterewardproducttoacrm(data, (err, response) => {
              this.loading = false
              this.getData()
            })
          }
        })
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        category_id: this.selectedcategory ? this.selectedcategory.id : '',
        search: this.filter.search, // filter
        limit: this.limit,
        offset: this.offset
      }
      api.getrewardproducttoacrm(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    },
    clearsearch() {
      this.filter.search = ''
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    showAdd() {
      this.edittype = 'create'
      this.editrewarddialog = 'true'
    },
    onChangeCategory(e) {
      this.selectedcategory = e
      this.getData()
    },
    onCategoryChange: function () {
      let vm = this
    }
  }
}
</script>

<style lang="scss" scoped>
.pos-top-r {
  position: absolute;
  right: 15px;
  top: 15px;
  color: rgb(64, 131, 255);
}
.pos-bot-r {
  position: absolute;
  right: 15px;
  bottom: 15px;
  color: rgb(64, 131, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Reward.vue